var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuHeartIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.633 6.647a6.093 6.093 0 0 0-1.334-1.94A6.22 6.22 0 0 0 15.93 2.93 6.26 6.26 0 0 0 12 4.315 6.26 6.26 0 0 0 8.07 2.93 6.219 6.219 0 0 0 3.7 4.706a6.057 6.057 0 0 0-1.825 4.329c0 .78.16 1.594.476 2.421.265.692.644 1.409 1.13 2.133.768 1.146 1.825 2.341 3.138 3.553a35.089 35.089 0 0 0 4.42 3.452l.556.357a.753.753 0 0 0 .808 0l.556-.357a35.535 35.535 0 0 0 4.42-3.452c1.312-1.212 2.37-2.407 3.138-3.553.485-.724.867-1.441 1.13-2.133.316-.827.476-1.64.476-2.421a5.968 5.968 0 0 0-.49-2.388z",
    fill: "#54585a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHeartIconGray);
export default __webpack_public_path__ + "static/media/menuHeartIconGray.2848394d.svg";
export { ForwardRef as ReactComponent };